import React, {useState} from "react";
import classes from "./StatScreen.module.css";
import StatNavBar from './statScreen/StatNavBar';
import LeadersBoard from './statScreen/LeadersBoard';
import RankDivBtn from './statScreen/RankDivBtn';
import BattleRatingDiv from './statScreen/BattleRatingDiv';
import ChartDiv from './statScreen/ChartDiv';
import GameModal from "../game/UI/GameModal";
import { useNavigate, useParams} from "react-router-dom"
import { useEffect, useMemo } from 'react';
import { useWallet } from '@solana/wallet-adapter-react'
import { Transaction, PublicKey } from '@solana/web3.js'
import { ASSOCIATED_TOKEN_PROGRAM_ID, Token, TOKEN_PROGRAM_ID } from '@solana/spl-token'
import { Metadata } from '@metaplex/js';
import * as anchor from '@project-serum/anchor';
import 'react-toastify/dist/ReactToastify.css';
import {leadersData, mechCollections} from "../../dummyData/data"
import AWS from "aws-sdk";
import LoaderSpinner from "./UI/LoaderSpinner";
import defaultMesh from "../../assets/Game/loading.png";


interface modalProps {
  show: boolean;
  title?: string;
  body?: string;
  onClickNo?: () => void;
  onClickYes?: () => void;
}

const configuration = {
  region: 'us-east-1',
  secretAccessKey: 'pbB5rUOe7+2ECT1fiDMQYp0DA0PJWPRFtejv92Ag',
  accessKeyId: 'AKIAWENPZQUFICV7X77K'
}

export interface StatProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

AWS.config.update(configuration)
var ddb = new AWS.DynamoDB.DocumentClient();

const StatScreen = (props: StatProps) => {
  const wallet = useWallet();
  const navigate = useNavigate()
  const { publicKey, signTransaction, sendTransaction } = wallet;
  const [disabled, setDisabled] = useState<boolean>(false);
  const token = new PublicKey('9g7MFEqPLtoDe3vyJx1JsqCFyKogHXxf6dDkuRxUUd9f');
  const [space, setSpace] = useState<number>(0);
  const [leaderboard, setLeaderBoard] = useState<any>([]);
  const [mechs, setMechs] = useState<Mech[]>([]);
  const [mechIndex, setMechIndex] = useState<number>(0);
  const [spaceKittyIndex, setSpaceKittyIndex] = useState<number>(0);
  const [spaceKitties, setSpaceKitties] = useState<SpaceKitty[]>([]);
  const DENOM = 1000000000;
  const connection = new anchor.web3.Connection(
    props.rpcHost ? props.rpcHost : anchor.web3.clusterApiUrl("mainnet-beta")
  )
  const matchesWon = 0;
  const [showModal, setShowModal] = useState<modalProps>({
    show: false,
    title: "",
    body: "",
  });

  class Mech {
    name: string;
    imageUrl: string;
    claimed: boolean;
    strength: number;
    agility: number;
    durability: number;
    efficiency: number;
    pilotSkills: number;
    
    constructor(
      name: string, 
      imageUrl: string, 
      claimed: boolean, 
      strength: number, 
      agility: number, 
      durability: number,
      efficiency: number, 
      pilotSkills: number) {

      this.name = name;
      this.imageUrl = imageUrl;
      this.claimed = claimed;
      this.strength = strength;
      this.agility = agility;
      this.durability = durability;
      this.efficiency = efficiency;
      this.pilotSkills = pilotSkills;
    }
  } 

  class SpaceKitty {
    name: string;
    imageUrl: string;
    constructor(name: string, imageUrl: string) {
      this.name = name;
      this.imageUrl = imageUrl;
    }
  }
  
  const [currentMech, setCurrentMech] = useState<Mech>(new Mech('#1', defaultMesh, false, 10, 10, 10, 10, 10));
  const [currentSpaceKitty, setCurrentSpaceKitty] = useState<SpaceKitty>(new SpaceKitty('#1', defaultMesh));

  const getSpace = async function() {
    if (!wallet || !wallet.publicKey) return 0

    const data = await connection.getParsedTokenAccountsByOwner(wallet.publicKey, {
      mint: token
    })
    // @ts-ignore
    setSpace(data.value[0].account.data.parsed.info.tokenAmount.uiAmountString);
    console.log(data.value[0].account.data.parsed.info.tokenAmount.uiAmountString);
  }

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const scan = async function(this: any) {
    if (!anchorWallet || disabled) return;
    setDisabled(true);
    console.log("Scanning for: " + anchorWallet.publicKey);
    const ownedMetadata = await Metadata.findByOwnerV2(connection, anchorWallet.publicKey);
    console.log(ownedMetadata);
    const spaceKitties = ownedMetadata.filter(metadata => (metadata.data.updateAuthority === 'AUNAtZquBHW1GNoAcZujpqzQyuRDihkxZmPP9rs5aZpJ' && metadata.data.data.name.includes('Space Kitty')))
    const battleMechs = ownedMetadata.filter(metadata => (metadata.data.updateAuthority === 'AUNAtZquBHW1GNoAcZujpqzQyuRDihkxZmPP9rs5aZpJ' && metadata.data.data.name.includes('Mech')))
    console.log("Space Kitties");
    console.log(spaceKitties);
    console.log("Battle Mechs");
    console.log(battleMechs);
    var mechs: Mech[] = []; 
    var kitties: SpaceKitty[] = [];

    for (const element of battleMechs) {
      const metadata = await Metadata.load(props.connection, element.pubkey);
      var read_params = {
        TableName: 'mech-metadata',
        Key: {
          name : metadata.data.data.name
        }
      };
      // @ts-ignore
      const mech = await readMech(read_params, metadata);
      mechs.push(mech);
      setMechs(mechs);
    }

    for (const element of spaceKitties) {
      const metadata = await Metadata.load(props.connection, element.pubkey);
      var read_params = {
        TableName: 'space-kitty-metadata',
        Key: {
          name : metadata.data.data.name
        }
      };
      const kitty = await readSpaceKitty(read_params, metadata);
      kitties.push(kitty);
      setSpaceKitties(kitties);
    }

    setDisabled(false);
  }

  const readMech = async function(read_params: any, metadata: any) : Promise<any>{
    // Call DynamoDB to read the item from the table
    console.log("READING");
    
    const str = roll();
    const agi = roll();
    const dur = roll();
    const efi = roll();
    const pil = roll();
    try {
      const data = await ddb.get(read_params).promise();
      if (data.Item !== undefined && data.Item !== null) {
        console.log("Success", JSON.stringify(data.Item));
        const item = data.Item;
        return new Mech(item.name, item.imageUrl, item.claimed, item.strength, item.agility, item.durability, item.efficiency, item.pilot_skills);
      } else {
        await fetch(metadata.data.data.uri)
        .then(response => response.json())
        .then(data => { 
          console.log(data);
          console.log(data.attributes);
          // If metadata doesn't exist, write to table
          var metadata_params = {
            TableName: 'mech-metadata',
            Item: {
              name : data.name,
              imageUrl: data.image,
              claimed : true,
              strength: str,
              agility: agi,
              durability: dur,
              efficiency: efi,
              pilot_skills: pil
            }
          }
          write(metadata_params);
          return new Mech(data.name, data.image, true, str, agi, dur, efi, pil)
        });
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  const readSpaceKitty = async function(read_params: any, metadata: any) : Promise<any>{
    // Call DynamoDB to read the item from the table
    console.log("READING");
    try {
      const data = await ddb.get(read_params).promise();
      if (data.Item !== undefined && data.Item !== null) {
        console.log("Success", JSON.stringify(data.Item));
        const item = data.Item;
        return new SpaceKitty(item.name, item.imageUrl);
      } else {
        await fetch(metadata.data.data.uri)
        .then(response => response.json())
        .then(data => { 
          console.log(data);
          console.log(data.attributes);
          // If metadata doesn't exist, write to table
          var metadata_params = {
            TableName: 'space-kitty-metadata',
            Item: {
              name : data.name,
              imageUrl: data.image
            }
          }
          write(metadata_params);
          return new SpaceKitty(data.name, data.image);
        });
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  const sendSPLTransaction = async function(amount: number) {
    const toPubkey = new PublicKey('AUNAtZquBHW1GNoAcZujpqzQyuRDihkxZmPP9rs5aZpJ');
    if (publicKey && signTransaction) {
      const fromTokenAccount = await Token.getAssociatedTokenAddress(
        ASSOCIATED_TOKEN_PROGRAM_ID,
        TOKEN_PROGRAM_ID,
        token,
        publicKey,
        true
      );
      const toTokenAccount = await Token.getAssociatedTokenAddress(
        ASSOCIATED_TOKEN_PROGRAM_ID,
        TOKEN_PROGRAM_ID,
        token,
        toPubkey,
        true
      );

      let transaction = new Transaction();
      transaction.add(
          Token.createTransferInstruction(
              TOKEN_PROGRAM_ID,
              fromTokenAccount,
              toTokenAccount,
              publicKey,
              [],
              amount * DENOM
          )
      );

      try {
        const blockHash = await connection.getRecentBlockhash()
        transaction.feePayer = publicKey
        transaction.recentBlockhash = await blockHash.blockhash
        const signed = await signTransaction(transaction)
        await connection.sendRawTransaction(signed.serialize())
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    }
    return false;
  }

  const roll = () => {
    const rolls = [];
    for (let i = 0; i < 4; i++) {
        rolls.push(Math.floor(Math.random() * 6) + 1);
    }
    rolls.sort();
    rolls.shift();
    return rolls.reduce((a, b) => a + b, 0);
  }

  const addMechStats = async function(mech: any) {
    if (mech === null) return

    const str = roll();
    const agi = roll();
    const dur = roll();
    const efi = roll();
    const pil = roll();

    if (!mech.claimed) {
      var metadata_params = {
        TableName: 'mech-metadata',
        Item: {
          name : mech.name,
          imageUrl: mech.imageUrl,
          claimed: true,
          strength: str,
          agility: agi,
          durability: dur,
          efficiency: efi,
          pilot_skills: pil
        }
      }
      write(metadata_params);
      setCurrentMech(new Mech(mech.name, mech.imageUrl, true, str, agi, dur, efi, pil));
      //update mech array
    } else {
      const paid = await sendSPLTransaction(1000);
      if (paid) {
        var metadata_params = {
          TableName: 'mech-metadata',
          Item: {
            name : mech.name,
            imageUrl: mech.imageUrl,
            claimed: true,
            strength: str,
            agility: agi,
            durability: dur,
            efficiency: efi,
            pilot_skills: pil
          }
        }
        write(metadata_params);
        setCurrentMech(new Mech(mech.name, mech.imageUrl, true, str, agi, dur, efi, pil));
        //update mech array
      }
    }
  }

  const write = async function(write_params: any) {
    ddb.put(write_params, function(err, data) {
      if (err) {
        console.log("Error", err);
      } else {
        console.log("Success", data);
      }
    });
  }

  const getRecord = async function() {
    if (wallet && wallet.publicKey) {
      var read_params = {
        TableName: 'match-history',
        Item: {
          address : wallet.publicKey.toBase58(),
          timestamp: Date.now(),
        }
      }
      const items = await ddb.scan(read_params).promise();
      let win = 0;
      let loss = 0;
      let latest = 0;
      items.Items?.forEach(item => {
        if (item.won) {
          win++;
        } else {
          loss++;
        }
        if (item.timestamp > latest) {
          latest = item.timestamp;
        }
      })
      console.log(win, loss, latest);
      return [win, loss, latest];
    }
  }

  const getLeaderBoard = async function() {
    const params = {
      TableName: 'match-history',
    };
    const items = await ddb.scan(params).promise();
    var map = new Map();
    var leaders: any[] = [];
    items.Items?.forEach(item => {
      if (map.has(item.mech)) {
        map.set(item.mech, map.get(item.mech) + 1);
      } else {
        map.set(item.mech, 1);
      }
    })
    // @ts-ignore
    const sorted = new Map([...map.entries()].sort((a, b) => b[1] - a[1]));
    console.log((Array.from(sorted.keys())));
    setLeaderBoard(Array.from(sorted.keys()).splice(0,9));
  }

    const totalMech = mechs.length
    const totalKitties = spaceKitties.length
  //next and prev btn control
  const nextMechBtnHandler = () => {
    if (totalMech <= 1) {
      return;
    } else {
      if (mechIndex + 1 >= totalMech) {
        setMechIndex(0)
      } else {
        setMechIndex(mechIndex + 1)
      }
      setCurrentMech(mechs[mechIndex])
    }
  }


  const prevMechBtnHandler = () => {
    if (totalMech <= 1) {
      return;
    } else {
      if (mechIndex - 1 < 0) {
      setMechIndex(totalMech - 1)
    } else {
      setMechIndex(mechIndex - 1)
    }
    setCurrentMech(mechs[mechIndex])
  }
    }
    
  const nextKittyBtnHandler = () => {
    if (totalKitties <= 1) {
      return;
    } else {
       if (spaceKittyIndex + 1 >= totalKitties) {
      setSpaceKittyIndex(0);
    } else {
      setSpaceKittyIndex(spaceKittyIndex + 1);
    }
    setCurrentSpaceKitty(spaceKitties[spaceKittyIndex])
   }
  }


  const prevKittyBtnHandler = () => {
    if (totalKitties <= 1) {
      return;
    } else {
      if (spaceKittyIndex - 1 < 0) {
      setSpaceKittyIndex(totalKitties - 1);
    } else {
      setSpaceKittyIndex(spaceKittyIndex - 1);
    }
    setCurrentSpaceKitty(spaceKitties[spaceKittyIndex])
    }
  }


  //action btn control
  const joinBtnHandler = () => {
    //show modal
    setShowModal({
      show: true,
      title: "Do you want to Join Game?",
      body: "Joining this game would cost you 100 $PACE",
      onClickYes: () => {
        //action to do on Yes click
        navigate("/vs", {state:{mechName: currentMech.name, 
          imageUrl: currentMech.imageUrl, 
          kittyName: currentSpaceKitty.name,
          spaceKittyUrl: currentSpaceKitty.imageUrl, 
          strength: currentMech.strength, 
          agility: currentMech.agility,
          durability: currentMech.durability,
          efficiency: currentMech.efficiency,
          pilotSkills: currentMech.pilotSkills,
          address: wallet != null  && wallet.publicKey != null ? wallet.publicKey.toBase58(): ''}})
      },
      onClickNo: () => {
         //action to do on NO click
        setShowModal({ show: false }) 
      }
    });
    
    };

    const repairBtnHandler = () => {
        //show modal
    setShowModal({
      show: true,
      title: "Do you want to Repair Mech?",
      body: "Repairing Mech would cost you 0.1eth",
      onClickYes: () => {
        //action to do on Yes click
        navigate("/vs")
      },
      onClickNo: () => {
         //action to do on NO click
        setShowModal({ show: false })     
      }
    });
    };

    const collectBtnHandler = () => {
         //show modal
    setShowModal({
      show: true,
      title: "Do you want to Collect Mesh?",
      body: "Connet to see the available meshs in your wallet",
      onClickYes: () => {
        //action to do on Yes click
        navigate("/vs")
      },
      onClickNo: () => {
         //action to do on NO click
        setShowModal({ show: false })
      }
    });
    };

  useEffect(() => {
    scan();
  }, [
    anchorWallet,
  ]);

  const refreshState = () => {
    (async () => {
      await getSpace();
      await getLeaderBoard();
      console.log(space);
      console.log(mechs);
      console.log(spaceKitties);
      console.log(mechIndex);
      console.log(currentMech);
      console.log(spaceKittyIndex);
    })();
  };

  //formating space(number) with k for thousands
  const [showSpace, setShowSpace] = useState("")
  function spaceFormatter(num: number) {
    let formatedSpace:any = Math.sign(num)*Math.abs(num)
    if (Math.abs(num) > 999) {
      formatedSpace = ((Math.abs(num) / 1000).toFixed(1))
      formatedSpace = formatedSpace * Math.sign(num)
      formatedSpace = formatedSpace + "k"
    }
    setShowSpace(formatedSpace)
    return formatedSpace;
  }

  useEffect(refreshState, [
    mechs,
    spaceKitties,
    mechIndex,
    spaceKittyIndex,
    currentMech
  ]);

  useEffect(() => {
    spaceFormatter(space)
  }, [space])
 
  return (
    <div className={classes["stat-screen-root"]}>
      {/* Game Modal Display  start*/}
      {showModal.show &&
        <GameModal
        title={showModal.title}
        body={showModal.body}
        onClickYes={showModal.onClickYes!}
        onClickNo={showModal.onClickNo!}
        />}
      {/* Game Modal Display  end*/}
      
      {/* Game Modal Display  start*/}
      {disabled &&
          <LoaderSpinner />
      }
        {/* Game Modal Display  end*/}
      
      <div className={classes["small-device"]} > Please Play game from a Large Screen </div>
      <div className={classes["space-div"]} >
        {showSpace &&
          <div> {showSpace}</div>
        }
        </div>
      <div className={classes["navbar-root"]}>
        <StatNavBar />
      </div>
      <div className={classes["stat-screen-frame"]}>
        <div data-aos="fade-up">
          <LeadersBoard leadersData={leaderboard} />
        </div>

        <div data-aos="fade-down">
          <RankDivBtn
            joinBtn={joinBtnHandler}
            collectBtn={collectBtnHandler}
            repairBtn={repairBtnHandler}
            matchesWon={matchesWon}
          />
        </div>
        <div data-aos="fade-up">

          <BattleRatingDiv
            nextClick={nextMechBtnHandler}
            prevClick={prevMechBtnHandler}
            currentMech={currentMech}
            addMechStats={addMechStats}
            total={totalMech}
          />
        </div>
        <div data-aos="fade-down">
          <ChartDiv
            nextClick={nextKittyBtnHandler}
            prevClick={prevKittyBtnHandler}
            spaceKitty={currentSpaceKitty}
            total={totalKitties}
          />
        </div>
      </div>
    </div>
  )
}

export default StatScreen;